// import React, { useEffect, useState } from 'react';
import React from 'react';
import { Trans } from '@lingui/macro';


// const ARTISTS = [

//   {
//     name: 'OLX',
//     time: '14:30 - 15:30',
//     genre: 'Techno',
//     info: "",
//     image: '/images/artists/olx.png',
//     video: '',
//     soundcloud: ''
//   },
//   {
//     name: 'GINET',
//     time: '15:30 - 16:30',
//     genre: 'Trance',
//     info: "",
//     image: '/images/artists/ginet.png',
//     video: '',
//     soundcloud: ''
//   },
//   {
//     name: 'GRYXX B2B JOSS',
//     time: '16:30 - 17:30',
//     genre: 'Melodic Dubstep',
//     info: "",
//     image: '/images/artists/gryxx-b2b-joss.png',
//     video: '',
//     soundcloud: ''
//   },
//   {
//     name: 'NARIMI',
//     time: '17:30 - 18:30',
//     genre: 'Drum and Bass',
//     info: "NARIMI (Marine Ferraiuolo) est une DJ et productrice de musique basée en France, reconnue pour ses sets de Drum & Bass énergiques. Elle s'est fait connaître à l'international grâce à des performances à Tokyo et à Amsterdam, notamment ses débuts au ZEROTOKYO, « l'une des plus grandes infrastructures de divertissement nocturne au Japon ». Passionnée par la musique électronique depuis son enfance, elle a développé son amour pour la Drum and Bass plus tard et a commencé à produire de la musique à l’âge de 21 ans. Peu de temps après, elle s’est mise au mix, se produisant lors de la soirée « More Bass More Good » organisée par l’artiste RetroVision. Cet événement a eu lieu dans le cadre de l’Amsterdam Dance Event (ADE). Marine a donné sa première performance en tant que NARIMI en France, devant plus de 1 000 personnes. Un mois plus tard, NARIMI s’est produite à l’international lors d’une soirée Drum and Bass à Tokyo, au Japon.",
//     image: '/images/artists/narimi.png',
//     video: 'bMMelH1uPuk?si=W5LQN_yJQfbPNxhw',
//     soundcloud: ''
//   },
//   {
//     name: 'CHVCK',
//     time: '18:30 - 19:30',
//     genre: 'Melodic House, Tech House',
//     info: "Né à Québec, CHVCK a grandi dans un environnement où la musique était omniprésente. Passionné de musique dès son plus jeune âge, il découvre la musique électronique à l'adolescence, marquant le début d'un long parcours musical. Au fil des ans, CHVCK a perfectionné l'art du DJing, développant un talent unique pour fusionner différents genres, de la house à la techno en passant par la trance. Sa créativité sans bornes et son goût pour l'expérimentation sonore l'ont amené à se tourner vers la production musicale, où il a rapidement fait ses preuves en sortant des morceaux et des remixes qui ont captivé l'attention de producteurs et de DJs influents. En tant que producteur, CHVCK a su fusionner avec brio des éléments de musique électronique et des influences diverses. Ses productions sont reconnues pour leur énergie, leur profondeur émotionnelle et leur capacité à créer des ambiances uniques. Ses performances live sont des événements incontournables, où il emmène le public dans un voyage musical intense. Son style distinctif, combiné à sa passion pour la musique, continue de faire de lui un DJ et producteur respecté et recherché dans l'industrie.",
//     image: '/images/artists/chvck.png',
//     video: '',
//     soundcloud: 'https://soundcloud.com/musicbychvck/floor-remix?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing'
//   },
//   {
//     name: 'BEN WILLO',
//     time: '19:30 - 20:30',
//     genre: 'Electro House',
//     info: "An emerging artist in the world of electronic music for 10 years, Benjamin Durette-Denis is known by the stage name Ben Willo. His new musical project ‘’Ben Willo’’ began 3 years ago, and he has successfully made a name for himself on the music scene by performing in various clubs, festivals, and venues across North America.",
//     image: '/images/artists/ben_willo.png',
//     video: '8xHDQcVqzFw?si=Q8A8oggTliPA_7BD',
//     soundcloud: ''
//   },
//   {
//     name: 'RETROVISION',
//     time: '20:30 - 22:00',
//     genre: 'Bass House, Future House',
//     info: "RetroVision, originating from a small village in southern France, represents the new generation of French DJ/producers. After building a strong online community through the support of YouTube curators, he broke through with his single \"Get Down\" on Tiësto's label Musical Freedom — one of the most played tracks of 2018 according to 1001Tracklists. Since then, he has continued to deliver hits on labels like HEXAGON, Musical Freedom, and STMPD, including the collaboration with Jonas Blue \"All Night Long,\" which reached #1 on the Billboard Dance chart and accumulated over 20 million streams. Ranked 6th in the Top 101 Producers of 1001Tracklists in 2020, RetroVision is also a prolific remixer, adding his signature touch to tracks by artists such as Alan Walker, R3HAB, and Galantis. With performances at the biggest festivals across Europe and Asia — including Tomorrowland and World Club Dome — he continues to establish his status as an essential producer for DJs worldwide.",
//     image: '/images/artists/retrovision.png',
//     video: '5cWlujMVY-8?si=pcLPlG28-PIEaaOb',
//     soundcloud: ''
//   },
//   {
//     name: 'WHYPER',
//     time: '22:00 - 23:00',
//     genre: 'Dubstep',
//     info: "WHYPER est un DJ et producteur montréalais montant, qui secoue les clubs et les festivals du Québec. Son style est ancré dans le dubstep et la bass music. En mars 2025, il a joué au Red Room à Montréal , et en février 2025, il participait à l'ArtikFest (After-Artik) à Trois-Rivières, où il a fait un set en B2B avec l'artiste Mushee.",
//     image: '/images/artists/whyper.png',
//     video: '',
//     soundcloud: 'https://soundcloud.com/whyperdubz/subtronics-eyes-cut-deeper-whyper-psychazm-remix?utm_source=clipboard&utm_medium=text&utm_campaign=social_sharing'
//   },
// ];

function LineUp() {
  // const [selectedArtist, setSelectedArtist] = useState(null);

  // useEffect(() => {
  //   const artistInfo = ARTISTS.reduce((acc, artist) => {
  //     acc[artist.name] = {
  //       info: artist.info,
  //       genre: artist.genre,
  //       image: artist.image || null,
  //       video: artist.video || null,
  //       soundcloud: artist.soundcloud || null
  //     };
  //     return acc;
  //   }, {});

    // const showArtistModal = (artist) => {
    //   const artistData = artistInfo[artist];
    //   setSelectedArtist({
    //     name: artist,
    //     info: artistData?.info || '',
    //     genre: artistData?.genre || '',
    //     image: artistData?.image || null,
    //     video: artistData?.video || null,
    //     soundcloud: artistData?.soundcloud || null
    //   });

    //   const modalElem = document.getElementById('artistModal');
    //   const modal = new window.bootstrap.Modal(modalElem);
    //   modal.show();

    //   const cleanup = () => {
    //     setSelectedArtist(null);
    //     const iframe = document.getElementById('artistVideo');
    //     if (iframe) iframe.src = '';
    //     const scIframe = document.getElementById('artistSoundcloudVideo');
    //     if (scIframe) scIframe.src = '';
    //     setTimeout(() => {
    //       const backdrops = document.querySelectorAll('.modal-backdrop');
    //       backdrops.forEach(b => b.remove());
    //       document.body.classList.remove('modal-open');
    //       document.body.style.paddingRight = '';
    //       document.body.style.overflow = '';
    //     }, 50);
    //   };

    //   modalElem.addEventListener('hidden.bs.modal', cleanup, { once: true });
    // };

    // const showImageModal = (imageSrc) => {
    //   const imageModal = document.getElementById('imageModal');
    //   const modalImage = document.getElementById('modalImage');
    //   modalImage.src = imageSrc;

    //   const modal = new window.bootstrap.Modal(imageModal);
    //   modal.show();

    //   imageModal.addEventListener('hidden.bs.modal', () => {
    //     const backdrop = document.querySelector('.modal-backdrop');
    //     if (backdrop) backdrop.remove();
    //     document.body.classList.remove('modal-open');
    //     document.body.style.paddingRight = '';
    //   }, { once: true });
    // };

    // const badges = document.querySelectorAll('.artist-badge');
    // badges.forEach((badge) => {
    //   badge.addEventListener('click', (event) => {
    //     const artist = event.currentTarget.getAttribute('data-artist');
    //     if (artist) showArtistModal(artist);
    //   });
    // });

    // const artistCards = document.querySelectorAll('.artist-card');
    // artistCards.forEach((card) => {
    //   card.addEventListener('click', () => {
    //     const artist = card.getAttribute('data-artist');
    //     if (artist) showArtistModal(artist);
    //   });
    // });

    // const lineupImage = document.getElementById('lineupImage');
    // if (lineupImage) {
    //   lineupImage.addEventListener('click', () => {
    //     showImageModal('images/artists/lineup.png');
    //   });
    // }

    // return () => {
    //   badges.forEach((badge) => badge.removeEventListener('click', () => {}));
    //   artistCards.forEach((card) => card.removeEventListener('click', () => {}));
    //   if (lineupImage) lineupImage.removeEventListener('click', () => {});
    // };
  // }, []);

  // const sortedArtists = [...ARTISTS].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <section className="section bg-white" id="line-up">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 mb-5">
            <div className="section-title text-center">
              <h2 className="title mb-3 text-dark">
                <Trans>LINE-UP</Trans>
              </h2>
              <p className="para-desc mx-auto mb-0 text-muted">
                {/* <Trans>Check out the amazing artists performing at Amaré Music Festival 2026!</Trans> */}
                <Trans>Thanks for being part of this year's edition. We'll see you next year with a brand new line-up!</Trans>
              </p>
            </div>
          </div>
        </div>

        {/* <div className="row justify-content-center mb-5">
          <div className="col-12 col-md-8 text-center">
            <h5 className="mb-3 text-dark">
              <Trans>Artists in Alphabetical Order</Trans>
            </h5>
            <div className="d-flex flex-wrap justify-content-center">
              {sortedArtists
                .filter(artist => artist.name)
                .map((artist, index) => (
                  <span
                    key={index}
                    className="badge m-1 artist-badge lineup-badge"
                    data-artist={artist.name}
                  >
                    {artist.name}
                  </span>
                ))}
            </div>
          </div>
        </div> */}

        {/* <div className="row g-4 justify-content-center">
          <h5 className="mb-3 text-dark text-center">
            <Trans>Timetable</Trans>
          </h5>
          {ARTISTS.map((artist, index) => (
            <div className="col-12 col-md-6 col-lg-4" key={index}>
              <div
                className={`artist-card ${artist.name ? 'has-artist' : 'empty-slot'}`}
                data-artist={artist.name}
                style={{ cursor: artist.name ? 'pointer' : 'default' }}
              >
                <div className="artist-card-glow"></div>
                <div className="artist-card-particles">
                  <div 
                    className="aurora" 
                    style={{
                      animationDuration: `${6 + (index % 3)}s`,
                      opacity: 0.5 + (index % 3) * 0.15
                    }}
                  ></div>
                  <div 
                    className="aurora-2" 
                    style={{
                      animationDuration: `${8 + (index % 4)}s`,
                      opacity: 0.5 + (index % 3) * 0.15
                    }}
                  ></div>
                  <div 
                    className="aurora-3" 
                    style={{
                      animationDuration: `${10 + (index % 2)}s`,
                      opacity: 0.5 + (index % 3) * 0.15
                    }}
                  ></div>
                </div>
                <div className="artist-card-content">
                  <div className="artist-time-badge">{artist.time}</div>
                  {artist.image ? (
                    <img
                      src={artist.image}
                      alt={artist.name}
                      className="artist-image mb-3"
                    />
                  ) : (
                    <div className="artist-placeholder mb-3">
                      <i className="mdi mdi-account"></i>
                    </div>
                  )}
                  <h3 className="artist-name">{artist.name ? artist.name : <Trans>TBA</Trans>}</h3>
                  {artist.genre && <p className="artist-genre">{artist.genre}</p>}
                  {artist.name && (
                    <span className="artist-cta">
                      <Trans>View Details</Trans>
                      <i className="mdi mdi-arrow-right ms-1"></i>
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div> */}

        {/* <div id="artistModal" className="modal fade" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="artist-modal-content">
              <div className="artist-modal-body">
                <button
                  type="button"
                  className="artist-close-btn"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="mdi mdi-close"></i>
                </button>
                <div className="artist-modal-header">
                  <img
                    id="artistImage"
                    src={selectedArtist?.image || ''}
                    alt=""
                    className="artist-modal-image"
                  />
                  <div className="artist-modal-info">
                    <h2 className="artist-modal-name">
                      {selectedArtist?.name || <Trans>Artist Information</Trans>}
                    </h2>
                    <p className="artist-modal-genre">{selectedArtist?.genre}</p>
                  </div>
                </div>
                <p className="artist-modal-desc">
                  {selectedArtist && selectedArtist.info ? (
                    selectedArtist.info
                  ) : (
                    <Trans>No information available.</Trans>
                  )}
                </p>

                <div id="artistVideoWrapper" style={{ display: selectedArtist?.video ? 'block' : 'none' }} className="artist-modal-video">
                  <div className="ratio ratio-16x9">
                    <iframe
                      id="artistVideo"
                      src={selectedArtist?.video ? `https://www.youtube.com/embed/${selectedArtist.video}` : ''}
                      title="Artist video"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>

                <div id="artistSoundcloudWrapper" style={{ display: selectedArtist?.soundcloud ? 'block' : 'none' }} className="artist-modal-video mt-3">
                  <iframe
                    id="artistSoundcloudVideo"
                    width="100%"
                    height="166"
                    scrolling="no"
                    frameBorder="no"
                    allow="autoplay"
                    src={selectedArtist?.soundcloud ? `https://w.soundcloud.com/player/?url=${selectedArtist.soundcloud}&color=%23ff5500&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false` : ''}
                    title="Artist SoundCloud track"
                  ></iframe>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div id="imageModal" className="modal fade" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h2 className="modal-title">Festival Lineup</h2>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body text-center">
                <img id="modalImage" src="" alt="Festival Lineup" className="img-fluid rounded" />
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </section>
  );
}

export default LineUp;